var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnergyDrink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 485.694 485.694",
    height: 512,
    viewBox: "0 0 485.694 485.694",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m113.737 74.39 21.208-39.8c5.355-10.049 15.071-16.21 25.565-16.21h165.017c10.437 0 20.11 6.095 25.483 16.058l21.517 39.895c2.776 5.147 4.243 11.038 4.243 17.042v308.238c0 6.004-1.467 11.895-4.243 17.042l-21.517 39.895c-5.374 9.963-15.046 16.058-25.483 16.058h-165.017c-10.494 0-20.21-6.161-25.565-16.21l-21.208-39.8c-2.724-5.112-4.161-10.946-4.161-16.89v-308.427c0-5.945 1.437-11.779 4.161-16.891z",
    fill: "#c2b2eb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m376.678 402.115c.057-.83.092-1.663.092-2.5v-308.241c0-1.999-.177-3.981-.497-5.931h-266.216c-.309 1.92-.481 3.872-.481 5.838v308.428c0 .805.031 1.607.084 2.407h267.018z",
    fill: "#9781dd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m218.692 354.883 90.117-118.516-36.652-17.967 28.676-69.847-97.907-.374-25.634 93.219 47.679 23.829z",
    fill: "#f6e06e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m372.527 74.334-21.517-39.896c-5.374-9.963-15.046-16.058-25.483-16.058h-44.737c8.275 0 15.944 4.833 20.204 12.732l17.06 31.631c2.201 4.081 3.364 8.751 3.364 13.511v244.384s1.619 32.019-8.594 44.501-18.606 13.373-32.033 13.373c-13.428 0-130.832 0-130.832 0-8.32 0-16.023-4.884-20.269-12.852l-16.814-31.555c-2.16-4.053-3.299-8.679-3.299-13.392v78.996c0 5.944 1.438 11.778 4.161 16.89l21.208 39.8c5.355 10.049 15.071 16.21 25.565 16.21h165.017c10.437 0 20.11-6.095 25.483-16.058l21.517-39.895c2.776-5.147 4.243-11.038 4.243-17.042v-308.239c-.001-6.004-1.468-11.894-4.244-17.041z",
    fill: "#b28be8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m321.418 85.443v235.195c0 16.625 1.619 32.02-8.594 44.501-10.213 12.482-18.606 13.373-32.033 13.373-13.428 0-130.832 0-130.832 0-8.32 0-16.023-4.884-20.269-12.852l-16.814-31.555c-2.16-4.053-3.299-8.679-3.299-13.392v78.996c0 .805.031 1.607.084 2.406h267.018c.057-.831.092-1.665.092-2.502v-308.238c0-1.999-.177-3.982-.497-5.933h-54.856z",
    fill: "#8962de"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m348.055 485.049h-209.765c-9.437 0-17.087-7.65-17.087-17.087v-3.879c0-9.437 7.65-17.087 17.087-17.087h209.765c9.437 0 17.087 7.65 17.087 17.087v3.879c0 9.437-7.65 17.087-17.087 17.087z",
    fill: "#c2b2eb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m348.055 38.698h-209.765c-9.437 0-17.087-7.65-17.087-17.087v-3.879c0-9.437 7.65-17.087 17.087-17.087h209.765c9.437 0 17.087 7.65 17.087 17.087v3.879c0 9.437-7.65 17.087-17.087 17.087z",
    fill: "#c2b2eb"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m348.981 50.925h-211.616c-5.523 0-10-4.477-10-10s4.477-10 10-10h211.616c5.523 0 10 4.477 10 10 0 5.522-4.477 10-10 10z",
    fill: "#a171e3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m188.122 130.757c-5.498 0-9.97-4.442-9.999-9.947-.029-5.522 4.424-10.023 9.947-10.053 19.285-.102 37.2-.102 56.378 0 5.523.029 9.976 4.53 9.947 10.053-.029 5.504-4.501 9.947-9.999 9.947-.018 0-.036 0-.054 0-19.105-.102-36.953-.102-56.166 0-.018 0-.036 0-.054 0z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m154.06 130.757h-12.076c-5.523 0-10-4.477-10-10s4.477-10 10-10h12.076c5.523 0 10 4.477 10 10 0 5.522-4.477 10-10 10z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m277.636 342.113c-3.314 0-6-2.686-6-6v-12.27c0-3.314 2.686-6 6-6s6 2.686 6 6v12.27c0 3.314-2.687 6-6 6z",
    fill: "#7844c1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m340.421 323.42c-3.313 0-6-2.687-6-6v-12.27c0-3.314 2.687-6 6-6s6 2.686 6 6v12.27c0 3.313-2.687 6-6 6z",
    fill: "#7844c1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m308.184 361.145c-3.313 0-6-2.687-6-6v-12.27c0-3.313 2.687-6 6-6 3.314 0 6 2.687 6 6v12.27c0 3.313-2.687 6-6 6z",
    fill: "#7844c1"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.937,
    cy: 78.826,
    fill: "#9781dd",
    rx: 17.937,
    ry: 17.937,
    transform: "matrix(.223 -.975 .975 .223 -62.904 78.711)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.853,
    cy: 160.757,
    fill: "#9781dd",
    r: 7.737
  }), /*#__PURE__*/React.createElement("path", {
    d: "m452.858 16.093 8.214 23.098c.352.989 1.048 1.773 1.927 2.168l20.521 9.246c2.899 1.306 2.899 5.925 0 7.232l-20.521 9.246c-.879.396-1.575 1.179-1.927 2.168l-8.214 23.098c-1.16 3.263-5.265 3.263-6.425 0l-8.214-23.098c-.352-.989-1.048-1.773-1.927-2.168l-20.521-9.246c-2.899-1.306-2.899-5.925 0-7.232l20.521-9.246c.879-.396 1.575-1.18 1.927-2.168l8.214-23.098c1.16-3.263 5.264-3.263 6.425 0z",
    fill: "#c2b2eb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergyDrink);
export default __webpack_public_path__ + "static/media/energy-drink.f29d9a61c40c5b9f5260821bc9252524.svg";
export { ForwardRef as ReactComponent };